// @flow

import React from 'react';
import { Field } from 'redux-form';
import { withRequired } from '../../validators';
import { ReduxFormLabeledSelect } from '../../../form/labeledFields';
import getValues from '../../../../helpers/getValues/getValues';

type OwnProps = {
  label: string,
  name: string,
  options: any,
  validate?: Array<Function>,
};

type Props = OwnProps;

const SelectField = ({
  label,
  name,
  options,
  validate,
}: Props) => (
  <Field
    label={label}
    name={name}
    component={ReduxFormLabeledSelect}
    validate={validate}
  >
    {options && getValues(options).map(option => <option value={option.value} key={`${name}-${option.value}`}>{option.label}</option>)}
  </Field>
);

SelectField.defaultProps = {
  validate: [],
};

export default withRequired<Props>(SelectField);
